import LocalStorageFunc from "../helpers/localStorageFunc";
import ApiCalls from "../config/apiCalls";
import Headers from "../config/headers";
import Utility from "./utility";

const pageNames = ["nextgen_homePage", "nextgen_cartPage","nextgen_customizationPage","nextgen_searchPage","nextgen_menuPage"];

const userObj = () => {
  const userData = LocalStorageFunc.getUserData();
  //console.log(userData);
  let user = {
    userAgent: navigator.userAgent,
    platform: window?._siteProps_ !== undefined && window?._siteProps_?.platform,
    userId: userData?.headers?.userId,
    //sessionId:"",
    timestamp: Date.now(),
    pageName: "",
    referrer: document.referrer,
    action: "",
    actionType: "",
    properties: {},
  };
  return user;
};

const itemAdded = (productId, quantity, pageNameIndex) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "itemAdded";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;
  obj.properties = {
    productId: (typeof productId !== 'undefined') ? productId : '',
    quantity: (typeof quantity !== 'undefined') ? quantity : '',
  };
  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
  return;
};

const itemRemoved = (productId, quantity, pageNameIndex) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "itemRemoved";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;
  obj.properties = {
    productId: (typeof productId !== 'undefined') ? productId : '',
    quantity: (typeof quantity !== 'undefined') ? quantity : '',
  };
  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
  return;
};

const pageView = (pageNameIndex,actionType) => {
  let obj = userObj();
  obj.action = "view";
  obj.actionType = actionType;
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;

  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
  return;
};

const loginStatus = (pageNameIndex) => {
  let obj = userObj();
  obj.action = "view";
  obj.actionType = "login";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;
  if (LocalStorageFunc.getUserData().hasOwnProperty("userData")) {
    let userData = LocalStorageFunc.getUserData()?.userData;
    if(userData && typeof(userData) === "string"){
     userData = Utility.decryptData(userData);
    }
    obj.properties = {
      loginType: userData.hasOwnProperty("loginType") ? userData.loginType : null,
      mobile: userData.hasOwnProperty("mobile") ? userData.mobile : null,
      email: userData.hasOwnProperty("email") ? userData.email : null,
      status: userData.isLoggedIn == true ? "loginSuccessfull" : "loginFailed",
    };
  }
  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
  return;
};

const rewards = (pageNameIndex, rewardId) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "rewardClicked";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;
  obj.properties = {
    rewardId: (typeof rewardId !== 'undefined') ? rewardId : '',
  };
  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
  return;
};

const rewardStatus = (pageNameIndex, rewardId, status) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "rewardStatus";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;
  obj.properties = {
    rewardId: (typeof rewardId !== 'undefined') ? rewardId : '',
    status: (typeof status !== 'undefined') ? status : '',
  };
  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
  return;
};

const searchKey = (pageNameIndex, searchQuery, listOfProduct) => {
  let obj = userObj();
  let listOfProductIds = [];
  for (let i = 0; i < listOfProduct.length; i++) {
    listOfProductIds.push(listOfProduct[i].id);
  }
  obj.action = "click";
  obj.actionType = "itemSearched";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;
  obj.properties = {
    searchQuery: (typeof searchQuery !== 'undefined') ? searchQuery : '',
    listedResultCount: (typeof listOfProduct !== 'undefined') ? listOfProduct.length: '',
    listOfProductIds: listOfProductIds,
  };
  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
  return;
};
//not completed as no vue component for pizza profile
const pizzaProfile = (
  pageNameIndex,
  crustLike,
  toppingsLike,
  toppingsDislike,
  specialDays
) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "pizzaProfileUpdated";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;
  obj.properties = {
    crustLike: [],
    toppingsLike: [],
    toppingsDislike: [],
    specialDays: {
      occassion: [],
      date: [],
    },
  };
  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
  return;
};

const paymentOfferSelected = (pageNameIndex, paymentOfferId) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "paymentOfferSelected";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;
  obj.properties = {
    paymentOfferId: (typeof paymentOfferId !== 'undefined') ? paymentOfferId : '',
  };
  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
  return;
};

const category = (pageNameIndex, selectedCategory) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "categorySelected";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;
  obj.properties = {
    selectedCategory: (typeof selectedCategory !== 'undefined') ? selectedCategory : '',
  };
  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
  return;
};

const hamburgerMenuView = (pageNameIndex) => {
  let obj = userObj();
  let userData = LocalStorageFunc.getUserData()?.userData;
  if(userData && typeof(userData) === "string"){
   userData = Utility.decryptData(userData);
  }
  obj.action = "click";
  obj.actionType = "hamburgerMenuView";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;
  // ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
  return;
};

const menuOpen = (pageNameIndex) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "menuClicked";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;

  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
  return;
};

const menuSelect = (pageNameIndex, value) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "menuSelected";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;
  obj.properties = {
    value: (typeof value !== 'undefined') ? value : '',
  };
  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
  return;
};

const menuClose = (pageNameIndex, value) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "menuClosed";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;
  obj.properties = {
    value: (typeof value !== 'undefined') ? (value === 0 ? "closedWithoutButton" : "closedWithButton"): '',
  };
  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
  return;
};

const promoOfferApplied = (pageNameIndex, offerId) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "promoOfferSelected";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;
  obj.properties = {
    offerId: (typeof offerId !== 'undefined') ? offerId : '',
  };
  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
  return;
};

const checkout = (pageNameIndex) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "checkout";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;

  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
  return;
};

const loginClicked = (pageNameIndex) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "login";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;
  // ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
  // console.log("LOGIN CLICKED");
};

const deliveryType = (typeSelected, pageNameIndex) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "deliveryType";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;
  obj.properties = {
    deliveryTypeSelected: (typeof typeSelected !== 'undefined') ? typeSelected?.orderType : '',
  };
  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
  // console.log("DELIVERY CLICKED");
};

const paymentOfferView = (offerId, pageNameIndex) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "paymentOfferViewed";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;
  obj.properties = {
    paymentOfferId: (typeof offerId !== 'undefined') ? offerId?.paymentId : '',
    appliedStatus: LocalStorageFunc.getPaymentOfferMode().label ? "applied" : "notApplied",
  };
  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
  // console.log("OFFER VIEWED");
};

const filterApplied = (filterName, filterValue, pageNameIndex) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "filterUpdated";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;
  obj.properties = {
    filterName: (typeof filterName !== 'undefined') ? filterName : '',
    filterValue: (typeof filterValue !== 'undefined') ? filterValue : '',
  };
  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
};

const customization = (pizzaProps, pageNameIndex) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "customization";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;
  obj.properties = (typeof pizzaProps !== 'undefined') ? pizzaProps : '';
  // console.log(obj);
  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
};

const hamburgerMenuOptionSelected = (optionSelected, pageNameIndex) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "hamburgerMenuOptionClicked";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;
  obj.properties = {
    optionSelected: (typeof optionSelected !== 'undefined') ? optionSelected : '',
  };
  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
};

const pizza99 = (pageNameIndex) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "pizza@99clicked";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;
  // ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
};

const location = (pageNameIndex) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "locationEdit";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;
  obj.properties = {
    location: "",
    latitude: "",
    longitude: "",
  };
  let locationData = LocalStorageFunc.getLastLocationNewOrLastLocationNewForIp();
  if (typeof locationData !== 'undefined' && locationData.length && locationData[0]?.recent) {
    obj.properties.location = locationData[0].recent?.city;
    obj.properties.latitude = locationData[0].recent?.latitude;
    obj.properties.longitude = locationData[0].recent?.longitude;
  }
  // console.log(userData.getCoordsFromRecentLocation());
  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
  // console.log("LOCATION");
};

const reorder = (pageNameIndex) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "reorderClicked";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;
  obj.properties = {
    typeOfCard: "Previous Order",
  };
  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
};

const promoOfferView = (promo, pageNameIndex) => {
  // console.log(promo);
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "promoOfferViewed";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;
  obj.properties = {
    offerId: (typeof promo !== 'undefined') ? (promo?.promoCode) : '',
  };
  //console.log(obj);
  // ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
};

const searchSelected = (productId, quantity, pageNameIndex) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "searchItemAdded";
  obj.pageName = (typeof pageNameIndex !== 'undefined') ? pageNames[pageNameIndex] : 0;
  obj.properties = {
    productId: (typeof productId !== 'undefined') ? productId : '',
    quantity: (typeof quantity !== 'undefined') ? quantity : '',
  };
  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
};

const searchClicked = (pageNameIndex) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "searchClicked";
  obj.pageName = pageNames[pageNameIndex];
  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
};

const searchCloseClicked = (pageNameIndex) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "searchCloseClicked";
  obj.pageName = pageNames[pageNameIndex];
  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
};

const customizeClicked = (pageNameIndex) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "customizeClicked";
  obj.pageName = pageNames[pageNameIndex];
  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
};

const customizeCloseClicked = (pageNameIndex) => {
  let obj = userObj();
  obj.action = "click";
  obj.actionType = "customizeCloseClicked";
  obj.pageName = pageNames[pageNameIndex];
  ApiCalls.USER_ACTIVITY_TRACKING_API(Headers(), obj);
};

export default {
  itemAdded,
  itemRemoved,
  pageView,
  loginStatus,
  rewards,
  rewardStatus,
  searchKey,
  pizzaProfile,
  paymentOfferSelected,
  category,
  hamburgerMenuView,
  menuOpen,
  menuSelect,
  menuClose,
  promoOfferApplied,
  checkout,
  loginClicked,
  deliveryType,
  paymentOfferView,
  filterApplied,
  customization,
  hamburgerMenuOptionSelected,
  pizza99,
  location,
  reorder,
  promoOfferView,
  searchSelected,
  searchClicked,
  searchCloseClicked,
  customizeClicked,
  customizeCloseClicked
};
